/** Клик по ячейке в режиме редактирования EdiTable — не toggles row checkbox. */
export function isEditableTableCellClick(target: HTMLElement | null | undefined): boolean {
  if (!target) return false

  if (
    target.closest(
      '.table-cell-editor, .table-cell-editor-checkbox, .table-cell-editor-listbox',
    )
  ) {
    return true
  }

  const cell = target.closest('td')
  if (!cell) return false

  if (cell.classList.contains('table-column-editable')) return true
  if (cell.classList.contains('p-cell-editing')) return true

  return false
}

function unwrapTableCellValue(value: unknown): unknown {
  let current = value
  for (let depth = 0; depth < 2; depth += 1) {
    if (!current || typeof current !== 'object' || Array.isArray(current) || !('value' in current)) {
      break
    }
    const inner = (current as { value?: unknown }).value
    if (inner === undefined) break
    current = inner
  }
  return current
}

/** Значение Checkbox/Boolean ячейки так, как его рисует TableCellRenderer. */
export function readTableBooleanCellValue(value: unknown): boolean {
  const target = unwrapTableCellValue(value)
  if (target === null || target === undefined || target === '') return false
  if (typeof target === 'boolean') return target
  if (typeof target === 'number') return target !== 0
  if (typeof target === 'string') {
    const normalized = target.trim().toLowerCase()
    return normalized === 'true' || normalized === '1' || normalized === 'y' || normalized === 'yes'
  }
  return false
}

export function readRowBooleanCellValue(row: unknown, field: string): boolean {
  if (!row || typeof row !== 'object' || !field) return false
  const record = row as Record<string, unknown>
  if (Object.prototype.hasOwnProperty.call(record, field)) {
    return readTableBooleanCellValue(record[field])
  }

  const backing = record._rowData
  if (backing && typeof backing === 'object') {
    const fields = (backing as { fields?: Record<string, unknown> }).fields
    if (fields && Object.prototype.hasOwnProperty.call(fields, field)) {
      return readTableBooleanCellValue(fields[field])
    }
    if (Object.prototype.hasOwnProperty.call(backing, field)) {
      return readTableBooleanCellValue((backing as Record<string, unknown>)[field])
    }
  }
  return false
}

export function nextTableBooleanCellValue(value: unknown): boolean {
  return !readTableBooleanCellValue(value)
}
